import { render, staticRenderFns } from "./InscriptionInput.vue?vue&type=template&id=5828304b&"
import script from "./InscriptionInput.vue?vue&type=script&lang=js&"
export * from "./InscriptionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports